




































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import ShelfUp from './product-shelfup.vue'
import DeductCost from './headfee-add.vue'
import BackPrinting from './back-printing.vue'
import HandleAbnormal from './back-updatestockstatus.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import { classPrintWorld } from '@/common/js/PrintWorld'
import moment from 'moment'
Vue.use(Preview);

class PagebackstockRequest extends PageRequest {
    beginTime?: Date;
    endTime?: Date;
    isLabel?: boolean;
    logisticsNumber: string;
    storeId?: number;
    productSku: string;
    userCode: string;
    productCode: string;
    productStatus?: number;
    receiveStatus?: number;
    productId?: number;
    shelfPosition: string;
    isPlan?: boolean;
    beginShelf?: Date;
    endShelf?: Date;
    isProcessLabel?: boolean;
    boxBatchNumber: string;
}

@Component({
    name: "backstockList",
    components: { DeductCost, ShelfUp, BackPrinting, HandleAbnormal }
})
export default class backstock extends AbpBase {
    shipmentReceiveStatus = Enums.getEnum(Enums.ShipmentReceiveStatus, true);
    editModalShow: boolean = false;
    settingCostModalShow: boolean = false;
    deductModalShow: boolean = false;
    deductshelfcostModalShow: boolean = false;
    shelfupModalShow: boolean = false;
    automaticJump: boolean = false;
    storeaddressList: Array<storeaddressInfo> = [];
    pagerequest: PagebackstockRequest = new PagebackstockRequest();
    IsCheckedStatus = Enums.getEnum(Enums.IsEffectiveStatus, true);
    ProductStatus = Enums.getEnum(Enums.ProductStatus, true);
    creationTime: Date[] = [moment(moment(new Date()).add(-30, 'days'), "YYYYMMDD").toDate(), new Date()];
    sheflTime: Date[];

    isArrived: boolean;
    isPrompt: boolean;
    printingModalShow: boolean = false;
    createModalShow: boolean = false;
    isLoadPrintList: boolean = false;
    abnormalModalShow: boolean = false;
    get list() {
        return this.$store.state.backstock.list;
    };
    get loading() {
        return this.$store.state.backstock.loading;
    }
    async add() {
        this.createModalShow = true;
    }
    pageChange(page: number) {
        this.$store.commit('backstock/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('backstock/setPageSize', pagesize);
        this.getpage();
    }
    async searchPage() {
        this.$store.state.backstock.currentPage = 1;
        this.getpage();
    }
    async getpage() {
        if (!this.pagerequest.storeId) {
            this.$Message.success("请选择备货仓库");
            return;
        }
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        }

        if (this.creationTime.length > 0) {
            this.pagerequest.beginShelf = this.sheflTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endShelf = this.sheflTime[1];
        }
        
        await this.$store.dispatch({
            type: 'backstock/getAll',
            data: this.pagerequest
        })

    }

    @Watch('$route.params.stockShipment')
    stockShipmentChange() {
        if (this.$route.params.stockShipment) {
            this.pagerequest = new PagebackstockRequest();
            this.$store.state.backstock.currentPage = 1;
            if (this.$route.params.storeId) {
                this.pagerequest.storeId = parseInt(this.$route.params.storeId);
            }
            this.pagerequest.logisticsNumber = this.$route.params.stockShipment;
            this.getpage();
        }


    }

    async operationData(name: any, data: any) {

    }
    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        if (this.storeaddressList.length == 1) {
            this.pagerequest.storeId = this.storeaddressList[0].id;
        }
        else {
            this.storeaddressList.push(a);
            this.pagerequest.storeId = null;
        }
    }
    async checkmodel(data: any) {
        this.$store.state.backstock.id = data.id;
        await this.$store.dispatch({
            type: 'backstock/isCheckPass',
            data: { id: data.id, ispass:true }
        })
        this.getpage();
    }
    async checknomodel(data: any) {
        //this.$store.state.backstock.id = data.id;
        await this.$store.dispatch({
            type: 'backstock/isCheckPass',
            data: { id: data.id, ispass: false }
        })
        this.getpage();
    }
    async warehosuesign(data: any, str: string) {
        if (str == "到达仓库") {
            await this.$store.dispatch({
                type: 'backstock/EditStatus',
                data: { id: data.id, isArrived: true }
            })
            this.getpage();
        }
        else {
            this.$store.state.backstock.id = data.id;
            this.$store.state.backstock.orderSite = data.orderSite;
            
            this.deductModalShow = true;
        }

    }

    async exportexpress() {
        await this.$store.dispatch({
            type: 'backstock/impotExcel',
            data: this.pagerequest
        })
    }

    async putShelf(data: any) {
        this.isPrompt = await this.$store.dispatch({
            type: 'backstock/ShelfUpCheck',
            data: { id: data.id}
        })
        if (this.isPrompt == false) {
            this.$Modal.warning({
                title: "提示", content: "需要设置仓储费和设置单个产品上架费才能上架！", onOk: async () => {
                    var productsku = data.productSku;
                    this.$router.push({ name: 'backstockproduct', params: { productSku: productsku } });
                }
            });
        }
        else {

            this.$store.state.backstock.id = data.id;
            this.$store.state.backstock.automaticJump = this.automaticJump;
            if (this.automaticJump) {
                var find = this.storeaddressList.filter(function (item) { return item.id == data.storeId });
                if (find[0].whetherLocal) {
                    this.$store.state.backstock.automaticPath = "intoLogistics";
                } else {
                    this.$store.state.backstock.automaticPath = "intoabroadLogistics";
                }
            }
            this.shelfupModalShow = true;
        }
    }
    async processLabel(data: any) {

        this.$Modal.confirm({
            title: "提示", content: "确认标记国内已贴标！", onOk: async () => {

                await this.$store.dispatch({
                    type: 'backstock/processLabel',
                    data: { id: data.id }
                });
                this.getpage();
            }
        });
    }

    async processabnormal (data: any) {
        this.$store.state.backstock.id = data.id;
        this.abnormalModalShow = true;
    }
    async kjprintTxm(data: any) {
        var barCode = data.barCode;
        var shelfPosition = (data.shelfPosition ? data.shelfPosition : "") + "_" + data.productId;
        if (!this.isLoadPrintList) {
            var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
            var json = {
                action: "", refresh: true, defaultprn: true, error: "", val: {}
            };
            json.action = "printers";
            json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
            json.defaultprn = true;                   //是否包含缺省打印机信息。
            json = printWorld.Direct(json);
            if (json == null) {//数据发送失败
                alert(printWorld.GetLastError());
            } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                alert(json.error);
            } else {    //处理包含打印机列表的json
            }


            var Options = new Array();
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                document.getElementById('SelectPrint').appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return;
        }
        var pdfData = {
            barCode: barCode,
            shelfPosition: shelfPosition,
            imageUrl: "",
            url: '',
            isDate: true,
            userId: abp.session.userId,
        };
        this.$store.commit('fontorder/getPdfUrl', pdfData);
        var printSelect: any = document.querySelector('#SelectPrint');
        if (!printSelect.value) {
            this.$Message.success("请选择指定打印机");
            return;
        }

        if (pdfData.url && pdfData.url.length > 0) {
            var jsonsList = [];
            var number = data.productNums;
            var printWorld = new classPrintWorld(); //new 一个打天下对象
            for (var j = 0; j < number; j++) {

                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                jsons.action = "printfile";
                jsons.format = "pdf_url";        //指定格式为pdf_url。
                jsons.content = pdfData.url;   //pdf文件的url路径
                jsons.paperlength = 6;
                jsons.paperwidth = 4;
                jsons.cert = "https://tkyc.ddtmx.com/cer/fileprintauth.ctf";
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                jsonsList.push(jsons);
            }
            printWorld.Direct(jsonsList);
        }


    }

    async printing(data: any, isLable: boolean) {
        this.$store.state.backstockproduct.barCode = data.barCode;
        this.$store.state.backstockproduct.shelfPosition = (data.shelfPosition ? data.shelfPosition : "") + "_" + data.productId;
        this.$store.state.backstockproduct.printCount = data.productNums;
        this.$store.state.backstockproduct.isLable = isLable;
        this.$store.state.backstockproduct.lableInfo = data.lableInfo;
        this.printingModalShow = true;
    }

    async jumpto() {
        (this.$refs.printingForm as any).resetFields();
        this.$emit('input', false);
        var timestamp1 = (new Date()).valueOf().toString();
        this.$router.push({ name: 'intoLogistics', params: { StockJumpPage: timestamp1 } });
    }

    //async printTxm(data:any   ) {
    //    this.$store.state.backstockproduct.barCode = data.barCode;
    //    this.$store.state.backstockproduct.shelfPosition = (data.shelfPosition ? data.shelfPosition : "") + "_" + data.productId;
    //    this.printingModalShow = true;
    //}

    get pageSize() {
        return this.$store.state.backstock.pageSize;
    }
    get totalCount() {
        return this.$store.state.backstock.totalCount;
    }
    get currentPage() {
        return this.$store.state.backstock.currentPage;
    }
    columns = [
        {
            title: '备货信息',
            width: 240,
            render: (h: any, params: any) => {
                var a = "red";

                return h('div', [h('h3', "国内物流单号:" + (params.row.logisticsNumber == null ? "" : params.row.logisticsNumber)), h('h3', "打包件数:" + (params.row.packageNums == null ? "" : params.row.packageNums)), h('h3', { style: { color: a } }, "产品状态：" + (params.row.productStatus == null ? "" : Enums.ProductStatus.filter(function (item) { return item.value == params.row.productStatus })[0].name))])
            }
        },
        {
            title: '其他信息',
            width: 300,
            render: (h: any, params: any) => {
                return h('div', [
                    h('h3', "产品内码:" + (params.row.productId == null ? "" : params.row.productId)),
                    h('h3', "货架号:" + (params.row.shelfPosition == null ? "" : params.row.shelfPosition)),
                    h('h3', "装箱批次:" + (params.row.boxBatchNumber == null ? "" : params.row.boxBatchNumber)),
                    h('h3', "计划批次:" + (params.row.planNumber == null ? "" : params.row.planNumber)),
                    h('h3', "运单号:" + (params.row.trackingNumber == null ? "" : params.row.trackingNumber)),
                    h('h3', "入库单号:" + (params.row.inStockNumber == null ? "" : params.row.inStockNumber))
                ])
            }
        },
        {
            title: '备货入库仓库',
            key: 'storeName',
            width: 150,
        }, {
            title: '快递状态',
            width: 90,
            key: 'receiveStatus',
            render: (h: any, params: any) => {

                var color = "";
                var name = "";
                if (params.row.receiveStatus !== null) {
                    var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == params.row.receiveStatus })[0];
                    var shipment = '';
                    var shelfNumber = '';
                    color = PackageStatus.color;
                    name = Enums.ShipmentReceiveStatus.filter(function (item) { return item.value == params.row.receiveStatus })[0].name;
                }

                return h('h3', { style: { color: color, display: "inline-block" } }, name);
            }
        }, {
            title: '快递货架号',
            key: 'shelfNumber',
            width: 100,
        },
        {
            title: '产品编码',
            key: 'barCode',
            width: 150,
        },
        {
            title: '产品内码',
            key: 'productId',
            width: 100,
        },
        {
            title: '产品货架号',
            key: 'shelfPosition',
            width: 100,
        },
        {
            title: '产品信息',
            width: 450,
            render: (h: any, params: any) => {
                var a = "red";
                return h('div', [h('h3', "类型:" + Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name), h('h2', { style: { color: a } }, "SKU:" + (params.row.productSku)), h('h2', { style: { color: 'blue' } }, "数量:" + (params.row.productNums)), h('h3', "名称:" + (params.row.productName)), h('h3', "链接:" + (params.row.productLink)), h('h3', "采购成本:" + (params.row.purchaseCost) + "元"), h('h3', { style: { color: a } }, "备注：" + (params.row.remark == null ? "" : params.row.remark))])
            }
        },
        //{
        //    title: '产品类型',
        //    width: 90,
        //    key: 'productType',
        //    render: (h: any, params: any) => {
        //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
        //    }
        //    },
        {
            title: '产品图片',
            key: 'productImgGuid',
            width: 95,
            render: (h: any, params: any) => {
                if (params.row.productImgGuid) {
                    var data = { imageGuid: params.row.productImgGuid, url: null };
                    var url = "";
                    if (params.row.productImgGuid.indexOf("http") != -1) {
                        url = params.row.productImgGuid;
                    }
                    else {
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        url = data.url;;
                    }

                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: "yc_" + params.row.id,
                            "preview-text": params.row.orderNumber + "cp"
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
        //{
        //title: '产品Sku',
        //    key: 'productSku',
        //width: 80,
        //},
        {
            title: '用户编码',
            key: 'userCode',
            width: 90,
        },
        {
            title: '是否审核通过',
            key: 'isCheckBy',
            width: 120,
            render: (h: any, params: any) => {
                return h('span', params.row.isCheckBy == null ? this.L('审核中') : (params.row.isCheckBy ? this.L('审核通过') : this.L('审核未通过')))
            }
        },
        //{
        //    title: '扣费详情',
        //    width: 280,
        //    render: (h: any, params: any) => {
        //        return h('div', [h('h3', "开始扣费时间:" + (params.row.beginDeductionTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)))), h('h3', "扣费周期:" + (params.row.deductionCycle == null ? "" : params.row.deductionCycle + "天")), h('h3', "扣除积分/周期:" + (params.row.deductIntegral == null ? "" : params.row.deductIntegral + "积分")), h('h3', "上架费:" + (params.row.shelfCost == null ? "" : params.row.shelfCost + "积分"))])
        //    }
        //},

        {
            title: '打包数量',
            key: 'packageNums',
            width: 90,
        },
        //{
        //    title: '商品链接',
        //    key: 'productLink',            //{
        //    title: '开始扣费时间',
        //    key: 'beginDeductionTime',
        //    width: 150,
        //    render: (h: any, params: any) => {
        //        return h('span', params.row.beginDeductionTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)));
        //    }
        //},
        //{
        //    title: '扣费积分',
        //    key: 'deductIntegral',
        //    width: 200,
        //},
        //{
        //    title: '扣费周期/积分',
        //    key: 'deductionCycle',
        //    width: 200,
        //},
        //    width: 200,
        //},
        //{
        //    title: '商品名称',
        //    key: 'productName',
        //    width: 200,
        //},
        //{
        //    title: '商品数量',
        //    key: 'productNums',
        //    width: 200,
        //},
        //{
        //    title: '采购成本',
        //    key: 'purchaseCost',
        //    width: 200,
        //},
        {
            title: '异常图片',
            key: 'abnormalImageGuid',
            width: 95,
            render: (h: any, params: any) => {
                if (params.row.abnormalImageGuid) {
                    var data = { imageGuid: params.row.abnormalImageGuid, url: null };
                    var url = "";
                    if (params.row.abnormalImageGuid.indexOf("http") != -1) {
                        url = params.row.abnormalImageGuid;
                    }
                    else {
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        url = data.url;;
                    }
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: "yc_" + params.row.id,
                            "preview-text": params.row.orderNumber + "cp"
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
        {
            title: '异常备注',
            key: 'abnormalRemark',
            width: 90,
        },
        {
            title: '时间',
            width: 230,
            render: (h: any, params: any) => {
                return h('div', [h('h3', "创建时间:" + (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime)))), h('h3', "更新时间:" + (params.row.lastModificationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.lastModificationTime)))), h('h3', "审核时间:" + (params.row.checkTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.checkTime)))), h('h3', "上架时间:" + (params.row.sheflTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.sheflTime))))])
            }
        },
        {
            title: '贴标处',
            width: 230,
            render: (h: any, params: any) => {
                var aryy = [];
                aryy.push(h('h3', "是否需要贴标:" + (params.row.isLabel ? "是" : "否")));
                aryy.push(h('h3', "是否处理:" + (params.row.isProcessLabel ? "是" : "否")));
                aryy.push(h('h3', "处理人:" + (params.row.processLabelUserName ? params.row.processLabelUserName : "")));
                aryy.push(h('h3', "处理时间:" + (params.row.processLabelTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.processLabelTime)))));
                return h('div', aryy);
            }
        },

        
        //{
        //title: '创建时间',
        //    key: 'creationTime',
        //width: 150,
        //    render: (h: any, params: any) => {
        //        return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
        //}
        //},
        //{
        //    title: '更新时间',
        //    key: 'lastModificationTime',
        //    width: 150,
        //    render: (h: any, params: any) => {
        //        return h('span', params.row.lastModificationTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.lastModificationTime)));
        //    }
        //},
        //{
        //   title: '备注',
        //   width: 220,
        //   key: 'reMark',
        // },
        {
            title: '操作',
            width: 120,
            fixed: 'left',
            key: 'id',
            render: (h: any, params: any) => {
                var data = params.row;
                var _this = this;
                var ss = data.storeName.indexOf("国内")
                var lable = "";
                if (ss < 0) {
                    lable = "转海外";
                }
                else {

                    lable = "到达仓库";
                }
                //var menu = [];
                //menu.push("审核通过");
                //menu.push("审核未通过");
                return h('div', [
                    //h('Dropdown', {
                    //    props: {
                    //        transfer: true,
                    //        trigger: 'click',
                    //    },
                    //    on: {
                    //        'on-click': (name) => {
                    //            _this.operationData(name, params.row);
                    //        }
                    //    }

                    //}, [
                    //    h('Button',
                    //        {
                    //            domProps: {
                    //                innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                    //            },
                    //            props: {
                    //                type: 'primary',
                    //            }

                    //        }),

                    //    h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                    //        return h('DropdownItem', { props: { name: item } }, item)
                    //    })
                    //    )],
                    //),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: params.row.isCheckBy ==null? "inline-block" : "none",

                        },
                        on: {
                            click: () => {
                                _this.checkmodel(params.row);

                            }
                        }

                    }, "审核通过"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: params.row.isCheckBy ==null? "inline-block" : "none",

                        },
                        on: {
                            click: () => {
                                _this.checknomodel(params.row);

                            }
                        }

                    }, "审核未通过"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: params.row.productStatus == 0 ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.warehosuesign(params.row, lable);

                            }
                        }

                    }, lable),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: params.row.productStatus == 1 ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.warehosuesign(params.row, "到达仓库");
                            }
                        }

                    }, "到达仓库"),
                    //h('Button', {
                    //    props: {
                    //        type: 'primary',
                    //        size: 'small',
                    //    },
                    //    style: {
                    //        marginTop: '5px',
                    //        width: '80px',
                    //        height: '30px',
                    //        display: params.row.productStatus == 2 ? "inline-block" : "none",
                    //    },
                    //    on: {
                    //        click: () => {
                    //            _this.deduct(params.row);

                    //        }
                    //    }

                    //}, "扣除上架费"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: params.row.productStatus == 2 ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.putShelf(params.row);

                            }
                        }

                    }, "上架"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: "inline-block",
                        },
                        on: {
                            click: () => {
                                _this.printing(params.row, false);

                            }
                        }

                    }, "打印条形码"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: "inline-block",
                        },
                        on: {
                            click: () => {
                                _this.printing(params.row, true);

                            }
                        }

                    }, "打印贴标码"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                          /*  display: params.row.productStatus == 3 ? "inline-block" : "none",*/
                        },
                        on: {
                            click: () => {
                                _this.processabnormal(params.row);

                            }
                        }
                    }, "标记异常"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '80px',
                            height: '30px',
                            display: !params.row.isProcessLabel? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                _this.processLabel(params.row);

                            }
                        }
                    }, "国内贴标"),
                    //h('Button', {
                    //    props: {
                    //        type: 'primary',
                    //        size: 'small',
                    //    },
                    //    style: {
                    //        marginTop: '5px',
                    //        width: '80px',
                    //        height: '30px',
                    //        display: params.row.productStatus == 3 ? "inline-block" : "none",
                    //    },
                    //    on: {
                    //        click: () => {
                    //            _this.printTxm(params.row);

                    //        }
                    //    }

                    //}, "批量打印条形码"),
   
                ]);

            }
        }
    ]
    async created() {
        this.getData();
        this.getpage();
    }
}
